function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UI-elements",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2640.000000, -682.000000)",
  id: "Tab-comfort-info",
  stroke: "#425CD4",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2625.000000, 677.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bezetting-blue",
  transform: "translate(16.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,11.875 L10,15.625 C10,16.3153559 9.44035594,16.875 8.75,16.875 L6.25,16.875",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,3.125 C10,2.43464406 9.44035594,1.875 8.75,1.875 L1.03833333,1.875 C0.808214688,1.875 0.621666667,2.06154802 0.621666667,2.29166667 L0.621666667,16.9 C0.622607607,17.0561143 0.710739266,17.1986046 0.85,17.2691667 L5.3975,19.0416667 C5.59004344,19.116915 5.80733901,19.0920878 5.97794669,18.9753475 C6.14855438,18.8586071 6.25040004,18.6650581 6.25,18.4583333 L6.25,4.80833333 C6.24941606,4.54834305 6.08773279,4.3159441 5.84416667,4.225 L0.625,2.28833333",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5625,4.93333333 C16.313967,5.18217619 15.9766979,5.32200073 15.625,5.32200073 C15.2733021,5.32200073 14.936033,5.18217619 14.6875,4.93333333",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9691667,6.85083333 C17.3477256,7.47273597 16.5045935,7.82215605 15.6254167,7.82215605 C14.7462398,7.82215605 13.9031078,7.47273597 13.2816667,6.85083333",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.375,9.07166667 C18.3805423,10.0664248 17.031588,10.6252993 15.625,10.6252993 C14.218412,10.6252993 12.8694577,10.0664248 11.875,9.07166667",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.125,0.625 L18.125,1.875 C18.125,2.56535594 17.5653559,3.125 16.875,3.125 L14.375,3.125 C13.6846441,3.125 13.125,2.56535594 13.125,1.875 L13.125,0.625 L18.125,0.625 Z",
  id: "Path"
})))));
function SvgOccupationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bezetting blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupationBlue);
export default __webpack_public_path__ + "static/media/occupation-blue.2c7003265039d6ddc12f6a53d0db5e05.svg";
export { ForwardRef as ReactComponent };